<template>
  <tr
    :style="{ cursor: SettingWorkDocsWorkAreaPage ? 'pointer' : null }"
    @click="
      SettingWorkDocsWorkAreaPage
        ? $router.push({ name: 'SettingWorkDocsWorkAreaProject', params: { id: item.id } })
        : ''
    "
  >
    <td>
      {{ item.name }}
    </td>
    <td v-if="!SettingWorkDocsWorkAreaPage">
      <div
        v-if="
          $userCheckAccess({
            abilities: 'edit_work_areas',
          })
        "
        class="buttons"
      >
        <WorkDocsWorkAreaModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-work_area']['dialog_delete'][
              'udalit-zonu-rabot'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
    <td v-else-if="$vuetify.breakpoint.mdAndUp"></td>
  </tr>
</template>

<script>
import WorkDocsWorkAreaModal from 'components/setting/workDocsWorkArea/WorkDocsWorkAreaModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkDocsWorkAreaTableItem',
  components: { WorkDocsWorkAreaModal, DeleteModal },
  props: ['item'],
  computed: {
    SettingWorkDocsWorkAreaPage() {
      return this.$route.name === 'SettingWorkDocsWorkArea'
    },
  },
}
</script>
